import { IconProps } from ".";

export const ChevronUpIcon: React.FC<IconProps> = (props) => {
  return (
    <svg viewBox="0 0 6 4" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M1 3L2.92929 1.07071C2.96834 1.03166 3.03166 1.03166 3.07071 1.07071L5 3"
        stroke="currentColor"
        strokeLinecap="round"
      />
    </svg>
  );
};
